import { SET_FIREBASE, RESET_REALTIME_DB, SET_MENU_DATA, SET_MENU_REALTIME } from '../actions/types/index';

const INITIAL_STATE = {
  drivers: [],
  independentDrivers: [],
  externalDrivers: [],
  finance: {},
  financeGlobalData: {},
  generalConfig: {},
  shops: {},
  shop: {},
  menu: {},
  menuShopId: null,
  menuPOS: {},
  pushNotifications: {},
  hotlineAvailability: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_FIREBASE:
      return { ...state, [action.id]: action.payload };
    case SET_MENU_DATA:
      return { ...state, menu: action.payload.menu, menuShopId: action.payload.menuShopId };
    case SET_MENU_REALTIME:
      return { ...state, menu: action.payload.menu, menuShopId: action.payload.menuShopId };
    case RESET_REALTIME_DB:
      return INITIAL_STATE;
    default:
      return state;
  }
};
